{
	"backToManageDeclarations": "Επιστροφή στη Διαχείριση δηλώσεων"
}
